
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import styles from './checkBox.module.css'
import { ChangeEvent } from 'react';


interface Props {
label?: React.ReactNode;
onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
checked?: boolean; 
}
  
const CustomCheckBox: React.FC<Props> = ({onChange, checked, ...props}): React.ReactElement =>{
    const {label} = props;

    return(
        <div className={styles.Wrapper} onChange={onChange}>
            <input className={styles.checkInput} type="checkbox" />
            <label className={styles.label}>{label}</label>
        </div>
    )

}

export default CustomCheckBox;



